import { Permission } from '@act/shared/authorization';
import { actingUserAppSelectors } from 'redux/slices/actingUserSlice.slice';

/** Reports subdomain permission flags derived from the acting user. */
export interface ReportsPermissions {
  canView: boolean;
  canEdit: boolean;
  canManageCustomers: boolean;
}

/**
 * Returns platform permission flags for the reports subdomain.
 * @returns View, edit, and customer-management capability booleans.
 */
export const useReportsPermissions = (): ReportsPermissions => {
  const canView = actingUserAppSelectors.useUserHasPermission(
    Permission.CAN_VIEW_REPORTS,
  );
  const canEdit = actingUserAppSelectors.useUserHasPermission(
    Permission.CAN_EDIT_REPORTS,
  );
  const canManageCustomers = actingUserAppSelectors.useUserHasPermission(
    Permission.CAN_MANAGE_REPORT_CUSTOMERS,
  );

  return { canView, canEdit, canManageCustomers };
};
